export const loadingConstants = {
    WAIT: 'LOADING_WAIT',
    PROGRESS: 'LOADING_PROGRESS',
    ERROR: 'LOADING_ERROR',
    READY: 'LOADING_READY'
};
